import * as ActionTypes from 'actions/Auth';

export default function reducer(
  state = {
    user: null,
    // authChecked is true once a session check has produced a definitive
    // result (valid token or failure). Protected rendering must wait for it
    // instead of relying on the global loading flag (NXT-598).
    authChecked: false,
    canCurrentUserCreateLicenses: undefined,
    parentOrg: null,
  },
  action
) {
  switch (action.type) {
    case ActionTypes.GET_TOKEN.FAILURE:
    case ActionTypes.LOGIN.FAILURE:
    case ActionTypes.LOGOUT.SUCCESS:
      return { ...state, user: null, authChecked: true, canCurrentUserCreateLicenses: undefined };
    case ActionTypes.SET_CAN_CREATE_LICENSES:
      return { ...state, canCurrentUserCreateLicenses: action.payload };
    case ActionTypes.GET_TOKEN.SUCCESS:
      return {
        ...state,
        user: action.payload,
        authChecked: true,
      };
    case ActionTypes.GET_ROLE_MANAGEMENT_REPRESANTATION.SUCCESS:
      return {
        ...state,
        roleManagementRepresantation: action.payload,
      };
    case ActionTypes.SET_PARENT_ORG:
      return {
        ...state,
        parentOrg: action.payload,
      };
    default:
      return state;
  }
}
